<template>
  <div class="index">
    <div class="bannerBox" v-if="bannerData.length > 0">
      <Swiper :list="bannerData" />
    </div>
    <div class="con01">
      <div class="con01Scroll">
        <div
          class="con01_item"
          v-for="(item, index) in recommendGameList"
          :key="index"
          @click="toGame(item.id)"
        >
          <img :src="item.icon" alt="" />
          <span class="con01_itemName">{{ item.name }}</span>
          <div class="con01_itemBtn" @click.stop="toGamePlay(item)">
            <span>进入</span>
          </div>
        </div>
      </div>
    </div>
    <div class="con02">
      <div class="con02Title">
        <div
          class="con02Title_item"
          v-for="(item, index) in con02Title_Data"
          :key="index"
          :class="{ active: titleType_sel == item.type }"
          @click="titleType_sel = item.type"
        >
          <div
            class="new"
            v-if="
              (item.type == 'active' && isNewtActivity) ||
              (item.type == 'message' && isNewtInformation)
            "
          >
            <img src="../../assets/img/new.png" alt="" />
          </div>
          <span>{{ item.title }}</span>
        </div>
      </div>

      <div class="listBox" v-if="isShowList">
        <HotGame v-if="titleType_sel == 'hot'" :list="hotGameList" />
        <NewGame v-else-if="titleType_sel == 'new'" :list="newGameList" />
        <Active v-else-if="titleType_sel == 'active'" :list="activeList" />
        <Message v-else-if="titleType_sel == 'message'" />
      </div>
    </div>
    <div
      class="winBox"
      v-if="
        $store.state.common.isShowDetail ||
        $store.state.common.giftGetType ||
        $store.state.common.giftExplain
      "
    >
      <Detail
        :detailMsg="$store.state.common.detailMsg"
        v-if="$store.state.common.isShowDetail"
      />
      <GiftTpye
        v-else-if="
          $store.state.common.giftGetType || $store.state.common.giftExplain
        "
      />
    </div>
  </div>
</template>
<script>
import Swiper from "@/components/swiper.vue";
import HotGame from "@/components/hotGame.vue";
import NewGame from "@/components/newGame.vue";
import Active from "@/components/active.vue";
import Message from "@/components/message.vue";
import Detail from "@/components/detail.vue";
import GiftTpye from "@/components/giftTpye.vue";
export default {
  name: "index",
  components: {
    Swiper,
    HotGame,
    NewGame,
    Active,
    Message,
    Detail,
    GiftTpye,
  },
  data() {
    return {
      userInfo: {},
      recommendGameList: [],
      con02Title_Data: [
        {
          type: "hot",
          title: "热门",
        },
        {
          type: "new",
          title: "新游",
        },
        {
          type: "active",
          title: "活动",
        },
        {
          type: "message",
          title: "资讯",
        },
      ],
      titleType_sel: "hot",
      bannerData: [],
      newGameList: [],
      hotGameList: [],
      recommendGameList: [],
      activeList: [],
      isShowList: false,
      isNewtActivity: 0,
      isNewtInformation: 0,
    };
  },
  created() {},
  mounted() {
    this.userInfo = localStorage.getItem("userInfo")
      ? JSON.parse(localStorage.getItem("userInfo"))
      : {};
    this.activateDevice();
    this.getBannerData();
    this.getIndexGame();
    this.getActiveGame();
  },
  methods: {
    activateDevice() {
      this.$api.reqData("/api/v1/device/add").then((res) => {});
    },
    getBannerData() {
      this.$api.reqData("/api/v1/index/getCarousel").then(
        (res) => {
          if (res.code == 200) {
            this.bannerData = res.data;
          } else {
            this.$toast.text(res.msg);
          }
        },
        (res) => {
          this.$toast.text(res.msg);
        }
      );
    },
    getIndexGame() {
      let data = {};
      this.$api.reqData("/api/v1/index/getGameList", data).then(
        (res) => {
          this.isShowList = true;
          this.newGameList = res.newGameList || []; //新游
          this.hotGameList = res.hotGameList || []; //热门
          this.recommendGameList = res.recommendGameList || []; //推荐
          this.isNewtActivity = res.isNewtActivity; //是否有新活动1有 0无
          this.isNewtInformation = res.isNewtInformation; //是否有新资讯1有 0无
        },
        (res) => {
          this.$toast.text(res.msg);
        }
      );
    },
    getActiveGame() {
      let data = {
        pageNum: 1,
        pageSize: 50,
      };
      this.$api.reqData("/api/v1/index/getActivityList", data).then(
        (res) => {
          if (res.code == 200) {
            this.activeList = res.data;
          } else {
            this.$toast.text(res.msg);
          }
        },
        (res) => {
          this.$toast.text(res.msg);
        }
      );
    },
    toGamePlay(item) {
      if (item.isSupportH5) {
        window.location.href = item.pcUrl;
      } else {
        this.$router.push({ name: "giftGame", query: { id: item.id } });
      }
    },
    toGame(id) {
      this.$router.push({ name: "game", query: { id: id } });
    },
  },
};
</script>
<style lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.index {
  @include flex_box(column, none, stretch);
  padding-bottom: 1rem;
  .bannerBox {
    width: 100%;
    height: 2.8rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .con01 {
    width: 7.5rem;
    @include flex_box(row, center, stretch);
    // height: 2.3rem;
    padding:.1rem 0 0;
    box-sizing: border-box;
    overflow: hidden;

  }
  .con01Scroll {
    @include flex_box(row, none, stretch);
    overflow-x: scroll;
    // border-bottom:1px solid #e7e7e7;
    margin-bottom:6px;
    padding-bottom:16px;
  }
  /* 设置滚动条整体宽度 */
  .con01Scroll::-webkit-scrollbar {
      height:2px;
  }

  /* 设置滚动条轨道颜色 */
  .con01Scroll::-webkit-scrollbar-track {
      background: #f1f1f1;
  }

  /* 设置滑块颜色 */
 .con01Scroll::-webkit-scrollbar-thumb {
      background-color: #ff913a;
  }

  .con01_item {
    font-size: 12px;
    color: #656565;
    @include flex_box(column, center, center);
    margin: 0 0.08rem;
    width: 1.9rem;
    min-width: 1.7rem;
    // padding: 0 .1rem;
    img {
      width: .9rem;
      height: .9rem;
    }
    span {
      // transform: scale(0.9);
      // transform-origin: center center;
      // white-space: nowrap;
    }
    .con01_itemName {
      line-height: 0.38rem;
    }
  }
  .con01_itemBtn {
    @include flex_box(row, center, center);
    background-color: #ff913a;
    width: 1rem;
    height: 0.36rem;
    border-radius: 4px;
    color: #fff;
  }
  .con02 {
    flex: 1;
    overflow: hidden;
    @include flex_box(column, none, stretch);
  }
  .con02Title {
    @include flex_box(row, center, stretch);
    padding-top: 0.1rem;
  }
  .con02Title_item {
    width: 1.86rem;
    height: 0.46rem;
    @include flex_box(row, center, center);
    font-size: 14px;
    color: #010101;
    border-bottom: 1px solid #e7e7e7;
    font-weight: bold;
    position: relative;
  }
  .con02Title_item.active {
    color: #fff;
    background: url("../../assets/img/title_bg.png") 0 0 no-repeat;
    background-size: 1.86rem auto;
  }
  .new {
    position: absolute;
    right: 0.2rem;
    top: -0.14rem;
    border-radius: 2px;
    @include flex_box(row, center, center);
    img {
      width: 0.5rem;
      height: auto;
    }
  }
  .listBox {
    flex: 1;
    overflow-y: scroll;
    @include flex_box(column, none, stretch);
  }
  .winBox {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    @include flex_box(column, center, center);
  }
  //积分未开放的弹窗提示
  .win_con {
    width: 5.92rem;
    height: 5.2rem;
    border-radius: 4px;
    background-color: #fff;
    @include flex_box(column, center, center);
    position: relative;
    color: #a5a5a5;
    font-size: 16px;
  }
  .close {
    position: absolute;
    top: 0;
    right: 0;
    width: 0.9rem;
    height: 0.9rem;
    @include flex_box(row, center, center);
    img {
      width: 0.32rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/index.vue